module.exports = __webpack_public_path__ + "img/msolve.2f302d39.png";